import * as React from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  'aria-controls': string;
  'aria-haspopup': boolean;
  'aria-label': string;
  hasAttachments: boolean;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

const FileAttachmentsButton = (props: Props): React.JSX.Element => {
  const {
    'aria-controls': ariaControls,
    'aria-haspopup': ariaHaspopup,
    'aria-label': ariaLabel,
    hasAttachments,
    onClick,
  } = props;

  return (
    <button
      aria-label={ariaLabel}
      aria-controls={ariaControls}
      aria-haspopup={ariaHaspopup}
      className="btn btn-default my-du-0"
      type="button"
      onClick={onClick}
    >
      {hasAttachments ? (
        <FormattedMessage defaultMessage="View attachments" />
      ) : (
        <FormattedMessage defaultMessage="+ Add an attachment" />
      )}
    </button>
  );
};

export default FileAttachmentsButton;
